export default __webpack_public_path__ + "static/media/Angular_JsonServer_Todo_AddingTask.08751399.png";